export interface AssetCountModel {
  propertyName: string;
  totalAssets: number;
  maintainableAssets: number;
  departmentWiseCounts: [
    {
      name: string;
      count: number;
    }
  ];
  criticalityWiseCounts: [
    {
      name: string;
      count: number;
    }
  ];
}
